<div class="copy-from-share-simple">
    <div slot="title" class="copy-from-switch">
        <h2 class="card-title">{{i18nLabel.nfsShareTitle}}</h2>
        <n-switch id="copy-from-nfs-s"
            [(ngModel)]="switch"
            (onChange)="onSwitchChange($event)"
            class="mb-8"
            *ngIf="!isExistNfs">
        </n-switch>
        <n-switch id="copy-from-nfs-s"
            [(ngModel)]="!isExistNfs"
            (onChange)="onSwitchChange($event)"
            [disabled]="isExistNfs"
            class="mb-8"
            *ngIf="isExistNfs">
        </n-switch>
    </div>

    <form *ngIf="switch && !isExistNfs && supportConfigPermission" [errorMessage]="errorMessage" [formGroup]="vm" [simpleMode]="true">
        <!-- 创建模式 -->
        <n-form-item [label]="i18nLabel.permissionTitle" class="create-style">
            <n-radio-group id="copy-from-nfs-share_style" formControlName="NFScreateStyle"
                (onChange)="onPermissionCreateStyleChange($event)">
                <n-radio id="copy-from-nfs-share_all"
                    [value]="CreateStyleE.All">
                    {{i18nLabel.allUserLab}}
                    <n-help-icon [content]="this.entry === FileSystemEntryE.AuditLog ?
                                                            i18nLabel.allUserLabReadOnlyTip : i18nLabel.allUserLabTip">
                    </n-help-icon>
                </n-radio>
                <n-radio id="copy-from-nfs-share_new"
                    [value]="CreateStyleE.New">
                    {{i18nLabel.manuUserLab}}
                    <n-help-icon [content]="i18nLabel.manuUserLabTip">
                    </n-help-icon>
                </n-radio>
            </n-radio-group>
        </n-form-item>

        <!-- NFS权限配置 -->
        <n-form-item labelHide="true" *ngIf="vm.value.NFScreateStyle === CreateStyleE.New" class="mt-16">
            <app-front-table-client-nfs-share
                [supportSmartGui]="supportSmartGui"
                [isCopyFrom]="isCopyFrom"
                [vstoreId]="vstoreId"
                [(tableData)]="clientList"
                [entry]="entry"
                [fileSystem]="fileSystem"
                (tableDataChange)="onTableClientNfsChange($event)">
            </app-front-table-client-nfs-share>
        </n-form-item>
    </form>
</div>
